import { collectionIndex } from "@/mocks/homeData";

export default function CollectionIndex() {
  return (
    <section id="archive" className="w-full px-4 py-10 md:px-8 md:py-16">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="font-label text-[11px] tracking-[0.24em] text-secondary-600">ARCHIVE</span>
          <h3 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            档案合集
          </h3>
        </div>
        <a
          href="#live"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 font-label text-sm text-foreground-800 transition-colors duration-200 hover:border-primary-400 hover:text-primary-700"
        >
          查看全部索引
          <i className="ri-arrow-right-up-line text-base" />
        </a>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {collectionIndex.map((item) => (
          <article
            key={item.no}
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors duration-200 hover:border-accent-400"
          >
            <div className="relative h-[150px] w-full overflow-hidden">
              <img
                src={item.image}
                alt={`44黑料区档案合集：${item.title}`}
                title={`${item.title} 44黑料区新料速递`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-md bg-background-50/95 font-heading text-sm font-black text-primary-600">
                {item.no}
              </span>
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center justify-between gap-2">
                <h4 className="font-heading text-base font-bold text-foreground-950">{item.title}</h4>
                <span className="shrink-0 font-label text-xs text-accent-700">{item.count}</span>
              </div>
              <p className="mt-3 font-body text-[13px] leading-6 text-foreground-600">{item.desc}</p>
              <a
                href="#live"
                className="mt-4 flex items-center gap-1.5 font-label text-xs font-medium text-primary-700 transition-colors duration-200 hover:text-primary-800"
              >
                进入合集
                <i className="ri-arrow-right-line text-sm" />
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}